import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "./ui/button";
import { ArrowRight } from "lucide-react";
import { track } from "../lib/analytics";

/**
 * Sticky bottom CTA that appears on mobile after the user scrolls past the hero.
 * Desktop is unaffected — the navbar already has a persistent CTA.
 */
export default function StickyCTA() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!show) return null;
  return (
    <div
      data-testid="sticky-mobile-cta"
      className="md:hidden fixed bottom-0 inset-x-0 z-40 px-4 pb-4 pt-2 pointer-events-none"
    >
      <div className="pointer-events-auto rounded-2xl bg-[#0f1724] text-white p-3 shadow-[0_20px_50px_-20px_rgba(15,23,36,0.6)] flex items-center justify-between gap-3 backdrop-blur">
        <div className="min-w-0">
          <p className="font-body text-[12px] text-white/70 leading-tight">3-day free trial · Cancel anytime</p>
          <p className="font-body text-[13px] font-medium leading-tight">Try Ascend Higher</p>
        </div>
        <Link to="/start" onClick={() => track("sticky_cta_click")}>
          <Button
            data-testid="sticky-cta-btn"
            className="h-10 px-4 rounded-full bg-[#486a8f] hover:bg-[#3a5a7c] text-white font-medium text-[12px] whitespace-nowrap"
          >
            Begin Today <ArrowRight size={13} className="ml-1.5" />
          </Button>
        </Link>
      </div>
    </div>
  );
}
